import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 1,
  class: "select-box__arrow"
}
const _hoisted_4 = ["onClick"]

import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { openConfirmModal } from '@/corePagesModule/components/modal/modalActions';
import { OrderStatusService } from '../domains/services/orderStatusService';
import { i18n } from '@/i18n';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectOrderStatusField',
  props: {
    index: {},
    modelValue: {},
    disabled: { type: Boolean, default: false },
    isShowArrow: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const selected = ref<OrderStatus>(props.modelValue);
const isOpen = ref(false);

const result = ref<DOMRect>();
const xLength = ref(0);
const yLength = ref(0);

const enableOptions = computed((): string[] => {
  return OrderStatusService.getEnabledNextOrderStatus(selected.value);
});

const disabledOptions: string[] = [OrderStatus.NoRecommendation, OrderStatus.Delivered, OrderStatus.DisplayEnded];

/**
 * ユーザーが選択を変更するときに確認モーダルを表示します。
 * @param value - 新しい選択値
 * @param beforeValue - 変更前の選択値
 * @returns モーダルの結果をPromiseで返します。
 */
const checkModal = async (value: OrderStatus, beforeValue: OrderStatus): Promise<boolean> => {
  if (!OrderStatusService.isUserConfirmationRequiredForChange(value, beforeValue)) return true;
  // モーダル表示
  const result = await openConfirmModal(
    'question',
    t('発注ステータス更新確認テキスト', { beforeStatus: t(beforeValue), afterStatus: t(value) }),
    t('変更する'),
    t('キャンセル')
  );
  return result !== undefined && result.isConfirmed;
};

const emit = __emit;

watch(
  () => props.modelValue,
  () => {
    selected.value = props.modelValue;
  }
);

watch(selected, (newValue, oldValue) => {
  checkModal(newValue as OrderStatus, oldValue as OrderStatus).then((result) => {
    if (result) {
      emit('update:modelValue', newValue);
    } else {
      selected.value = oldValue;
    }
  });
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
  if (isOpen.value) {
    const element = document.getElementById(`order-status-select-container${props.index}`);
    if (!element) return;
    result.value = element.getBoundingClientRect();
    xLength.value = result.value.left;
    yLength.value = result.value.bottom;
  }
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param option - 選択されたオプション
 */
const selectOption = (option: OrderStatus) => {
  if (enableOptions.value.includes(option)) {
    selected.value = option;
    emit('update:modelValue', option);
    isOpen.value = false;
  }
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!(event.target as Element).closest(`#order-status-select-${props.index}`)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `order-status-select-${_ctx.index}`,
    class: "select-box"
  }, [
    _createElementVNode("div", {
      id: `order-status-select-container${_ctx.index}`,
      class: _normalizeClass(["select-box__selected", { 'select-box__selected--disabled': _ctx.disabled }]),
      onClick: toggleDropdown
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["select-box__field", `select-box__field--${selected.value}`])
      }, _toDisplayString(_unref(t)(selected.value)), 3),
      (_ctx.isShowArrow)
        ? (_openBlock(), _createBlock(SvgLoader, {
            key: 0,
            name: "arrowDown",
            class: "select-box__arrow"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3))
    ], 10, _hoisted_2),
    (isOpen.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "select-box__dropdown",
            style: _normalizeStyle({
          top: `${yLength.value}px`,
          left: `${xLength.value}px`,
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OrderStatus), (option) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: option,
                class: _normalizeClass(["select-box__option", { 'select-box__option--disabled': !enableOptions.value.includes(option) }]),
                onClick: ($event: any) => (selectOption(option))
              }, _toDisplayString(_unref(t)(option)), 11, _hoisted_4)), [
                [_vShow, !disabledOptions.includes(option)]
              ])
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})